// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Select from '../controls/Select'
import { InputCell } from '../AudienceEdit'
import type { OptionType } from '../types'
import { translateFunc, translations } from '../../shared/localize'
import LabeledWrapper from './LabeledWrapper'

type Props = {|
  visible: boolean,
  options: Array<OptionType>,
  campaignId: number,
  campaignName: string,
  campaignLabel: string,
  campaignErrors: Array<string>,
  campaignNameLabel: string,
  campaignNameErrors?: Array<string>,
  onChange: Function
|}

const newCampaignKey = 0

const t = translateFunc(translations.audience_edit.campaign)

export default class CampaignSelect extends Component<Props> {
  render() {
    const {
      campaignLabel,
      campaignErrors,
      campaignNameLabel,
      campaignNameErrors,
      visible,
      campaignId,
      campaignName
    } = this.props

    return (
      <div>
        <LabeledWrapper label={campaignLabel} errors={campaignErrors}>
          <InputCell className="audience-campaign-wrapper">
            <Select
              value={campaignId}
              options={this.campaignOptions()}
              onChange={(val) => this.selectedCampaignChanged(val)}
            />
          </InputCell>
        </LabeledWrapper>
        {visible && campaignId === newCampaignKey && (
          <LabeledWrapper label={campaignNameLabel} errors={campaignNameErrors} twoLines>
            <InputCell>
              <input
                className="input-item input-item_full-width"
                type="text"
                id="audience_campaign_name"
                value={campaignName}
                onChange={(e) => this.campaignNameChanged(e.target.value)}
              />
            </InputCell>
          </LabeledWrapper>
        )}
      </div>
    )
  }

  selectedCampaignChanged(id: string) {
    this.changed({ campaignId: parseInt(id) })
  }

  campaignNameChanged(name: string) {
    this.changed({ campaignName: name })
  }

  changed(diff: Object) {
    this.props.onChange(diff)
  }

  newRecordInputOption(): Array<OptionType> {
    if (!this.props.visible) return []
    return [{ id: newCampaignKey, name: t('placeholder') }]
  }

  campaignOptions(): Array<OptionType> {
    return _.concat(this.newRecordInputOption(), this.props.options)
  }
}
